<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="type"
          placeholder="选择策略"
          style="width: 100%"
          class=""
          filterable
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in sourceTypeList"
            :key="index"
            :label="item.strategyName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="status"
          placeholder="推送状态"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          style="width: 100%"
          v-model="textType"
          placeholder="类型"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,key) in typeList"
            :key="key"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="12"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          class="mar-bot10 header-item"
          v-model="pickerTime"
          type="daterange"
          align="left"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        <!--@change="toQuery"-->
        </el-date-picker>
        <select-date-duration
          class="header-item"
          v-model="pickerTime"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryTypeList } from "@/api/wx/strategyActicle";
import  { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  data() {
    return {
      type: '',
      sourceTypeList: [],
      status: '',
      statusList:[
        {value:0,name:'未推送'},
        {value:1,name:'已推送'},
        {value:2,name:'已失效'}
      ],
      textType: '',
      typeList:[
        {value:1,name:'文本'},
        {value:2,name:'图片'},
        {value:3,name:'图文'}
      ],
      pickerTime: []
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
   this.getTypeList();
  },
  methods: {
    toQuery(){
      this.$emit('toQuery');
    },
    getTypeList(){
      queryTypeList({
        page: 1,
        limit: 500,
        'sidx': 'id',
        'order':'desc',
      }).then((res) => {
        this.sourceTypeList = res.page.list;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
}
</style>
